import React, { Component } from 'react';
import NavigationBar from "./Nav";

export default class Header extends Component {
  render() {
    return (
        <NavigationBar />
    )
  }
}



// WEBPACK FOOTER //
// src/components/Header/Header.js